<template>
	<div class = "div1">
		<el-backtop target = ".div1"></el-backtop>
		<!-- 头部 -->
		<Head :data = "searchList"></Head>
		<!-- 中部内容 -->
		<div style = "background: #F6F5F7;">
			<!-- 导航 -->
			<!-- <div class = "navigation">
				<div class = "navList">
					<div v-for = "(item,index) in navList" :key = "index" :class = "index==active?'active':''" class = "navName"
						 @click = "onNavigation(index,item)">{{ item.title }}</div>
				</div>
			</div> -->
			<!-- 第一部分 -->
			<div class = "ones tong" v-if = "active==0">
				<!-- 左边 -->
				<div class = "ist is_left">
<!--					<div class="left_title">家用电器</div>-->
					<div class = "left_list">
						<div class = "listName" v-for = "(item,index) in leftList" :key = "index">
							<!-- <span v-for = "(item1,index1) in item.children" :key = "index1"> -->
								<span class = "nameCl" @click = "onClick(item.id)">{{ item.name }}</span>
								<!-- <span v-if = "(index1+1) < item.children.length">/</span> -->
							<!-- </span> -->
						</div>
					</div>
				</div>
				<!-- 中间 -->
				<div class = "ist is_conts">
					<el-carousel height = "440px">
						<el-carousel-item v-for = "(item,index) in bannerList" :key = "index">
							<img :src = "item.imgUrl" class = "bannerName" @click = "bannerSkip(item)"/>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			
			<!-- 第三部分 -->
			<!-- <div class = "tong three" v-if = "active==0">
				<div class = "navList2">
					<div v-for = "(item,index) in navList1" :key = "index" :class = "index==active1?'active1':''" class = "navName1"
						 @click = "onNavigation1(index,item)">
						 {{ item.title }}
					</div>
				</div>
			</div> -->
			<div class = "tong three" v-if = "active!=0">
				<div class = "table_main">
					<table>
						<tbody>
							<tr>
								<th class = "left-th">{{ $t('commodity.sort') }}</th>
								<th class = "border-bt right-th">
									<div v-for = "(item,index) in classList1" :key = "index" :class = "index==active3?'active2':''"
										 class = "className" @click = "classOn1(index,item)">{{ item.title }}</div>
								</th>
							</tr>
						</tbody>
					</table>

				</div>
			</div>
			<div class = "tong three" v-if = "dataList.content.length!=0">
				<goodsItem v-if="title != '拼团购'" :title = "title" :isVip = "member&&member>0?true: false"
						   :data = "dataList.content"></goodsItem>
			</div>
			<div class = "tong three" v-if = "dataList.content.length!=0">
				<el-pagination background style = "text-align: center;padding-bottom: 50px;" layout = "prev, pager, next"
							   :total = "dataList.totalElements" @current-change = "handleCurrentChange" :current-page = "page"
							   :page-size = "size">
				</el-pagination>
			</div>
			<div class = "emptyWrap" v-if = "dataList.content.length==0">
				<img src = "../../../static/images/empty.png" alt = "">
				<div style = "">{{$t('commodity.none')}}</div>
			</div>

		</div>
		<!-- 底部 -->
		<Foots></Foots>
	</div>
</template>

<script>
	import Head from '@/components/head.vue'
	import Foots from '@/components/foots.vue'
	import goodsItem from "../../components/goods-item";
	import goodsItem3 from "../../components/goods-item3";
	export default {
		components: {
			Head,
			Foots,
			goodsItem,
			goodsItem3
		},
		data() {
			return {
				page: 1,
				size: 10,
				dengji: '',
				dengjides: '',
				sort: 'createAt',
				searchList: [],
				navList: [],
				navList1: [],
				active: 0,
				active1: 0,
				active2: 0,
				active3: 0,
				number1: '',
				number2: '',
				number3: '',
				bannerList: [],
				leftList: [],
				secondsList: [],

				dataList: {
					content: []
				},
				classList1: [
					{
						title: '综合',
						type: 'createAt'
					}, {
						title: '销量',
						type: 'sales'
					}, {
						title: '超低价',
						type: 'price'
					}
				],


				member: this.$cookie.get('member'),	//是否展示折扣价
				image_url: '',	//头像
				nickName: '',	//用户名
				invitationCode: '',
				phone: '',	//电话
				isLogin: false,
				// userId : this.$cookie.get('userId'),
				dingdanCountList: {
					count1: 0,
					count2: 0,
					count3: 0,
					count4: 0,
					count5: 0,
				},	//订单数量
				type: 'createAt',
				title: '热卖榜单',

				navlist: [],

				jingXuan: [],
				reMai: [],
				gonggaoList:[],
				meiRi: [],
				pinTuan: [],
				classId:1,
				version:'en',
			}
		},
		mounted() {
			if(!this.$cookie.get('language')){
				this.$i18n.locale = 'en'
				this.$cookie.set('language', 'en')
			}
			this.dataSelect()
			this.bannerSelect()
			this.classSelect()
			this.classSelectP()
			this.getLeftList()
			this.getHomeGongGao()
			this.getSearchList()
			if (this.userId) {
				this.getOrderCount()
				this.userSelect()
			}
			var version = this.version
			setInterval(() => {
				version = this.$cookie.get('language')
				if(version!=this.version){
					this.version = version
					this.dataSelect()
					this.bannerSelect()
					this.classSelect()
					this.classSelectP()
					this.getLeftList()
					this.getHomeGongGao()
					this.getSearchList()
					console.log(version,'5----tihs.version：',this.version)
				}
			}, 1000)
			
			
		},
		computed: {
			userId() {
				return this.$cookie.get('userId')
			},
		},
		methods: {
			getSearchList() {
				if(this.version == 'en'){
					var url = '/common/type/404'
				}else{
					var url = '/common/type/290'
				}
				this.$http({
					url: this.$http.adornUrl(url),	//热词
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						this.searchList = data.data.value.split(',')
					}
					
				})
			},
			getHomeGongGao(){
				this.$http({
					url: this.$http.adornUrl('/message/page/1/0/5'),
					method: 'get',
				}).then(({data}) => {
					this.gonggaoList = data.data
				})
			},
			//跳转订单页面
			goOrder() {
				this.$router.push({
					path: '/order'
				})
			},
			//轮播图跳转
			bannerSkip(e) {
				// window.location.href = e.linkUrl
			},
			onNavigation(index, item) {
				this.active = index
				this.active3 = 0  //重置排序
				this.page = 1
				this.title = item.title
				this.page = 1
				if (this.title == '拼团购') {
					this.sort = 'createTime'
				} else {
					this.sort = 'createAt'
				}
				if (this.active) {
					this.getDataList()
				}
			},
			getDataList() {
				console.log('this.title:',this.title)
				if (this.title == '热卖榜单') {
					this.$http({
						url: this.$http.adornUrl('/goods/selling'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
						})
					}).then(({data}) => {
						if (data.status == 0) {
							this.dataList = data.data
						}
					})
				} else if (this.title == '精选好物') {
					this.$http({
						url: this.$http.adornUrl('/goods/selectGoods'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
						})
					}).then(({data}) => {
						if (data.status == 0) {
							this.dataList = data.data
						}
					})
				} else if (this.title == '每日上新') {
					this.$http({
						url: this.$http.adornUrl('/goods/news'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
						})
					}).then(({data}) => {
						if (data.status == 0) {
							this.dataList = data.data
						}
					})
				} else if (this.title == '拼团购') {

					this.$http({
						url: this.$http.adornUrl('/selfGroup/userList'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
						})
					}).then(({data}) => {
						if (data.status == 0) {
							this.dataList = data.data
						}
					})
				} else {
					this.$http({
						url: this.$http.adornUrl('/goods/userList'),
						method: 'get',
						params: this.$http.adornParams({
							'page': this.page - 1,
							'size': this.size,
							'sort': this.sort,
							'type': this.type
						})
					}).then(({data}) => {
						this.dataList = data.data
					})
				}
			},
			onNavigation1(index, item) {
				this.active1 = index
				this.page = 1
				this.type = item.url.slice(item.url.indexOf('cid=') + 4, item.url.indexOf('&'))
				this.sort = 'createAt'
				this.classId = item.id
				
				if (item.title == '热卖榜单') {
					this.title = '热卖榜单'
					
					this.dataSelect()
				} else {
					this.title = ''
					this.dataSelect()
				}
			},
			classOn(index) {
				this.active2 = index
			},
			classOn1(index, item) {
				this.page = 1
				this.active3 = index
				this.sort = item.type
				if (this.title == '拼团购' && this.active3 == 1) {
					this.sort = 'groupNumber'
				}
				this.getDataList()
			},
			onClick(id) {
				this.$router.push({
					path: '/productList?type=' + id
				})
			},
			handleCurrentChange(val) {
				this.page = val
				if (this.active == 0) {
					this.dataSelect()
				} else {
					this.getDataList()
				}
			},
			quanbuClick() {
				console.log('点击查看全部')
			},
			// 商品数据分类
			classSelect() {
				this.$http({
					url: this.$http.adornUrl('/selfActivity/list'),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({data}) => {
					// this.navList1 = data.data

					this.navlist = [];
					this.jingXuan = [];
					this.reMai = [];
					this.meiRi = [];
					this.pinTuan = [];
					this.secondsList = []
					data.data.forEach(d => {
						if (d.state == '1') {
							this.navlist.push(d);
							// this.secondsList[0] = d
						} else if (d.state == '2') {
							this.jingXuan.push(d);
							this.secondsList.push(d);
							// this.secondsList[1] = d
						} else if (d.state == '3') {
							this.reMai.push(d);
							this.secondsList.push(d);
							// this.secondsList[2] = d
						} else if (d.state == '4') {
							this.meiRi.push(d);
							this.secondsList.push(d);
							// this.secondsList[3] = d
						} else if (d.state == '5') {
							this.pinTuan.push(d);
							this.secondsList.push(d);
							// this.secondsList[4] = d
						}
					});
				})
			},
			// 商品分类
			classSelectP() {
				this.$http({
					url: this.$http.adornUrl('/selfActivity/state'),
					method: 'get',
					params: this.$http.adornParams({
						state:10
					})
				}).then(({data}) => {
					this.navList1 = data.data
			
				})
			},
			// 获取商品数据
			dataSelect() {
				console.log('-----------this.title：',this.title)
				if (this.title == '热卖榜单'||this.classId==21) {
					this.$http({
						url: this.$http.adornUrl('/goods/selling'),
						method: 'get',
						params: this.$http.adornParams({
							'page': this.page - 1,
							'size': this.size,
							'sort': this.sort
						})
					}).then(({data}) => {
						this.dataList = data.data
					})
				} else {
					this.$http({
						url: this.$http.adornUrl('/goods/userList'),
						method: 'get',
						params: this.$http.adornParams({
							'page': this.page - 1,
							'size': this.size,
							'sort': this.sort,
							'type': this.type
						})
					}).then(({data}) => {
						this.dataList = data.data
					})
				}

			},
			// 获取轮播图
			bannerSelect() {
				this.$http({
					url: this.$http.adornUrl('/advert/list'),
					method: 'get',
					params: this.$http.adornParams({
						type: 2
					})
				}).then(({data}) => {
					this.bannerList = data.data
				})
			},
			// 获取用户信息
			userSelect() {
				this.$http({
					url: this.$http.adornUrl('/user/' + this.userId),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({data}) => {
					if (data.status == 0) {
						this.isLogin = true
						this.member = data.data.member
						this.image_url = data.data.image_url
						this.nickName = data.data.nickName
						this.invitationCode = data.data.invitationCode
						this.phone = data.data.phone
						if (data.data.gradeDes) {
							this.dengji = data.data.gradeDes;
						} else {
							this.dengji = '已邀请0人';
						}
						if (data.data.gradeNumber) {
							// this.dengjides = data.data.gradeNumber;
							if (data.data.gradeNumber == '还可邀请0人') {
								this.dengjides = '已到达最高等级';
							} else {
								this.dengjides = data.data.gradeNumber;
							}
						} else {
							// this.dengjides = '还可邀请0人'
							// let number = this.$queue.invitaionNum();
							// this.dengjides = '还可邀请' + number + '人';
						}
						this.$cookie.set('member', data.data.member)
						this.$cookie.set('image_url', data.data.image_url)
						this.$cookie.set('nickName', data.data.nickName)
						this.$cookie.set('phone', data.data.phone)
					}
				})
			},
			// 商品数据分类
			getOrderCount() {
				this.$http({
					url: this.$http.adornUrl('/orders/count?userId=' + this.userId),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({data}) => {
					if (data.status === 0) {
						this.dingdanCountList = data.data;
					}
				})
			},
			getLeftList() {
				this.$http({
					url: this.$http.adornUrl('/goodsType/list'),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({data}) => {
					if (data.status === 0) {
						this.leftList = data.data;
					}
				})
			},
			switchover(item) {
				this.$router.push({
					path: '/productList2?id=' + item.id + '&title=' +item.title
				})
			},

			/* 登录 */
			goLogin() {
				this.$router.push({
					path: '/login'
				})
			},


		}
	}
</script>

<style scoped>
	.div1 {
		height: 100vh;
		overflow-x: hidden;
	}

	/* 导航 */
	.navigation {
		background: #FF2D55;
		height: 40px;
		line-height: 40px;
		color: #fff;
	}

	.navList {
		width: 1200px;
		margin: 0 auto;
	}

	.navName {
		display: inline-block;
		width: 20%;
		text-align: center;
		cursor: pointer;
	}

	.active {
		background: #e5284c;
		color: #fff;
	}

	/* 第一部分 */
	.tong {
		width: 1200px;
		margin: 0 auto;
		margin-top: 15px;
	}

	.ones {
		height: 450px;
	}

	.ist {
		display: inline-block;
		height: 440px;
		box-sizing: border-box;
	}

	.is_left {
		width: 20%;
		overflow-y:auto;
		margin-right: 1.5%;
		line-height: 40px;
		padding: 20px;
		color: #333333;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		float: left;
	}

	.nameCl:hover {
		color: #287EFF;
		cursor: pointer;
	}

	.is_conts {
		width: 78.5%;
		height: 400px;
	}

	.bannerName {
		width: 100%;
		height: 100%;
	}

	.is_right {
		width: 25%;
		color: #333333;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		box-sizing: border-box;
		height: 440px;
		float: right;
	}

	.rightTop {
		padding: 20px;
	}

	.imgTop {
		width: 50px;
		height: 50px;
		/* border-radius: 50%; */
		float: left;
	}

	.topR {
		margin-left: 60px;
		line-height: 25px;
	}

	.topL {
		margin-left: 60px;
		line-height: 50px;
		height: 50px;
	}

	.topL > div:hover {
		cursor: pointer;
	}

	.Rname {
		font-size: 20px;
	}

	.Ryaoqingma {
		font-size: 14px;
	}

	.rightVip {
		margin: 0 20px 15px;
		padding: 0;
		height: 40px;
		border-radius: 5px;
		background: #FF2D55;
		color: #fff;
	}

	.rightVip div {
		display: inline-block;
	}

	.rightNoVip {
		margin: 0 20px 15px;
		height: 40px;
		border-radius: 5px;
		background: #FF2D55;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 40px;
		padding: 0 20px;
		font-size: 16px;
	}

	.rightBtn {
		width: 80px;
		height: 27px;
		text-align: center;
		font-size: 12px;
		color: #333;
		border-radius: 16px;
		z-index: 1;
		background: #fde3de;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.vipName {
		line-height: 40px;
		padding-left: 15px;
		font-size: 18px;
		font-weight: 600;
	}

	.vipKthy {
		background: #fff;
		font-size: 12px;
		color: #FF2D55;
		height: 20px;
		line-height: 20px;
		margin-left: 36%;
		padding: 0 6px;
		border-radius: 20px;
	}

	.vipKthy:hover {
		cursor: pointer;
	}

	.Rclass {
		padding: 0 20px 15px;
		border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
		margin-top: 30px;
	}

	.classList {
		display: inline-block;
		width: 23%;
		text-align: center;
		cursor: pointer;
	}

	.RlistNum {
		font-size: 24px;
		font-weight: 600;
	}

	.RlistName {
		font-size: 14px;
	}

	.Rbottom {
		padding: 15px 20px;

	}

	.bottomTitle {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 15px;
	}

	.bottomS {
		font-size: 12px;
		margin: 20px 0px;
	}

	.bottomList {
		padding: 15px 0;
	}

	.listI {
		display: inline-block;
		width: 32%;
		text-align: center;
	}

	.bottomImg {
		width: 34px;
	}

	/* 第二部分 */
	.seconds {
		background: url(../../assets/index/bg.png) no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		height: 275px;
		border-radius: 5px;
	}

	.secondsleft {
		width: 15%;
		float: left;
		color: #fff;
		font-size: 18px;
		padding: 20px;
		box-sizing: border-box;
	}

	.secondsleft_title {
		font-size: 30px;
		font-weight: 600;
		line-height: 40px;
	}

	.secondsleft_dixy {
		height: 177px;
	}

	.chakan {
		cursor: pointer;
	}

	.secondsRight {
		margin-left: 16%;
		border: none;
		border-radius: 6px;
		background: #fff;
		border: 1px solid #FF2D55;
		box-sizing: border-box;
	}

	.secondsRight_list {
		display: inline-block;
		width: 20%;
		box-sizing: border-box;
		padding: 20px;
		font-size: 18px;
		cursor: pointer;

	}

	.secondsRight_title {
		line-height: 30px;
		color: #333;
		font-weight: 600;
		text-align: center;
	}

	.secondsRight_sm {
		font-size: 13px;
		color: #999;
		margin-bottom: 20px;
		text-align: center;
	}

	.secondsRight_img {
		width: 100%;
		height: 161px;
	}

	/* 第三部分 */
	.navList2 {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
		color: #333;
		background: #fff;
		border-radius: 2px;
	}

	.navName1 {
		display: inline-block;
		width: 16.66%;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
	}

	.active1 {
		background: #FF2D55;
		color: #fff;
	}

	/* 筛选表格 */
	.table_main table {
		width: 100%;
	}

	.table_main {
		border: 1px solid #e8e8e8;

	}

	table tr {
		/* border-bottom: 1px solid #e8e8e8; */
		background: #fff;
	}

	table tr th {
		padding: 16px 24px;
		/* border-right: 1px solid #e8e8e8; */
		/* border-bottom: 1px solid #e8e8e8; */
	}

	table tr td {
		padding: 16px 24px;
		/* border-right: 1px solid #e8e8e8; */
		border-bottom: 1px solid #e8e8e8;
	}

	table th {
		color: rgba(0, 0, 0, .85);
		font-weight: 400;
		font-size: 14px;
		line-height: 1.5;
	}

	.border-rt {
		border-right: none !important;
	}

	.border-bt {
		border-bottom: none !important;
	}

	.left-th {
		color: #333;
		width: 50px;
		line-height: 50px;
	}

	.right-th {
		text-align: left;
		padding-left: 30px;
	}

	.className {
		display: inline-block;
		/* width: 50px; */
		background-color: #fff;
		font-size: 14px;
		color: #333;
		margin: 10px 5px;
		padding: 0 20px;
		text-align: center;
		cursor: pointer;
	}

	.active2 {
		background: #FF2D55;
		color: #fff;
		border-radius: 4px;
	}

	.yxl {
		width: 70px;
		margin: 0 50px 0 10px;
		border: 1px solid #E6E6E6;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
	}

	.jiage1 {
		margin: 0 20px;
		width: 50px;
	}

	.emptyWrap {
		width: 100%;
		text-align: center;
		margin: 80px 0;
	}

	.emptyWrap > div {
		font-size: 24px;
		font-weight: 700;
		color: #999999;
	}

</style>



// WEBPACK FOOTER //
// src/views/homePage/index.vue